
import React from "react";
import { useRef } from "react";

import { Button } from '@chakra-ui/button';
import { Input } from '@chakra-ui/input';
// import React from 'react'
// import { useRef } from 'react'
import styles from "./ProductsAdd.module.css";
import { Heading } from '@chakra-ui/layout';

const ProductsAdd = () => {
  const titleRef = useRef();
  const priceRef = useRef();
  const discountRef = useRef();
  const ratingRef = useRef();
  const ratingCountRef = useRef();
  const categoryRef = useRef();
  const serviceRef = useRef();
  const timeRef = useRef();
  const descriptionRef = useRef();
  const imagesRef = useRef();


 

  const addProduct=()=>{
    return true
  }
  return (
    <div className={styles.main}>
      <Heading size='lg' marginLeft={'10px'}>Add Products</Heading>
      <Input marginBottom={'5px'} type="text" placeholder="title" ref={titleRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="price" ref={priceRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="discount" ref={discountRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="rating" ref={ratingRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="rating Count" ref={ratingCountRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="category" ref={categoryRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="service" ref={serviceRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="time" ref={timeRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="description seprate with ," ref={descriptionRef} /><br/>
      <Input marginBottom={'5px'} type="text" placeholder="image url" ref={imagesRef} /><br/>
      <br/>
      <Button onClick={addProduct}>Add</Button>
      <br/><br/>
    </div>
  );
};

export default ProductsAdd;
